import {
  Maybe,
  SubscriptionStatus,
  AccountInput,
  VerticalID,
  Args,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import { planFeatureIconString } from '../../fragments/__generated__/PlanFeatureIcon'

import { featureFragmentString } from '../../fragments/__generated__/FeatureFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { minimalSponsorFragmentString } from '../../fragments/__generated__/MinimalSponsorFragment'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { planFeatureFragmentString } from '../../fragments/__generated__/PlanFeatureFragment'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import createAffiliateRawString from '../CreateAffiliate.graphql'

const createAffiliateString = [
  createAffiliateRawString,
  accountFragmentString,
  expenseReloadString,
  bankAccountFragmentString,
  addressFragmentString,
  planFeatureIconString,
  featureFragmentString,
  storefrontString,
  minimalSponsorFragmentString,
  stripeSubscriptionString,
  subscriptionMetadataString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  creditCardFragmentString,
  subscriptionFeaturesString,
  planFeatureFragmentString,
  userSettingsFragmentString,
].join('\n\n')

export type CreateAffiliateData = {
  createDistributor: {
    account: Maybe<AccountFragment>
    subscription: Maybe<{
      status: SubscriptionStatus
      currentPeriodEnd: string
    }>
    error: Maybe<string>
  }
  createUserLoginLink: {
    link: Maybe<string>
  }
}

export type CreateAffiliateVariables = {
  account: AccountInput
  govId1: string
  govId2?: Maybe<string>
  stripeToken?: Maybe<string>
  affiliate?: Maybe<boolean>
  verticalId: VerticalID
  queryParams: Args
}

export type CreateAffiliate = Operation<
  CreateAffiliateData,
  CreateAffiliateVariables
>

export const CreateAffiliate = ({
  account,
  govId1,
  govId2,
  stripeToken,
  affiliate,
  verticalId,
  queryParams,
}: CreateAffiliateVariables): CreateAffiliate => ({
  query: createAffiliateString,
  variables: {
    account: AccountInput(account),
    govId1,
    govId2,
    stripeToken,
    affiliate,
    verticalId,
    queryParams: Args(queryParams),
  },
})
